import apiService from '@/services/apiService'

const Media = {
  getUserImage (fileName) {
    return `${apiService.root}/api/pictures/${fileName}`;
  },
  updateProfilePicture (data, id) {
    const request = new FormData()
    request.append('img', data)
    return apiService.post('api/media/user_picture/' + id, request, 'application/x-www-form-urlencoded')
  }
}

export default Media



// WEBPACK FOOTER //
// ./src/services/api/media.js